import $ from "jquery";

const animOptions = {
    duration: 200,
    easing: "linear"
};
const animFadeOutLeft = {
    keyframes: [
        { },
        { opacity: "0", transform: "translateX(-50px)" },
    ]
};
const animFadeInRight = {
    keyframes: [
        { opacity: "0", transform: "translateX(50px)" },
        { },
    ]
};

$(function() {
    const $qtool = $(".qtool");
    if($qtool.length == 0) {
        return;
    }

    const $header = $("header");
    const $headerTitle = $("#headertitle");

    function gotoQuestion(questionName, animate) {
        const $oldQuestion = $qtool.find(".question:visible");
        const $newQuestion = $qtool.find(".question[data-name='"+questionName+"']");
        
        if(animate) {
            $oldQuestion.get(0).animate(animFadeOutLeft.keyframes, animOptions).finished.then(() => {
                showNewQuestion();
            });
        } else {
            showNewQuestion();
        }

        function showNewQuestion() {
            $oldQuestion.hide();
            $newQuestion.show();
            $headerTitle.text($newQuestion.data("title"));
            const headerbg = $newQuestion.data("headerbg");
            if(!headerbg) {
                $header.removeAttr("data-bg");
            } else {
                $header.attr("data-bg", headerbg);
            }
            if(animate) {
                $newQuestion.get(0).animate(animFadeInRight.keyframes, animOptions);
            }
        }
    }

    $(document).on("click", "[data-gotoquestion]", function() {
        const questionName = $(this).data("gotoquestion");
        history.pushState({}, "", "entscheidungshilfe#"+questionName);
        gotoQuestion(questionName, true);
    });

    window.onhashchange = function() {
        if(window.location.hash.length > 1) {
            gotoQuestion(window.location.hash.substring(1), true);
        }
    };

    //On load, if hash is present, go to corresponding question
    if(window.location.hash.length > 1) {
        gotoQuestion(window.location.hash.substring(1), false);
    }
});

